const dev = {
	API_ENDPOINT_URL: '/api',
	AUTH_SERVICE: 'https://auth-service-613016217150.australia-southeast1.run.app',
	USER_SERVICE: 'https://user-service-613016217150.australia-southeast1.run.app',
	MISSION_CONTROL_SERVICE: 'https://mission-control-service-613016217150.australia-southeast1.run.app'
};

const prod = {
	API_ENDPOINT_URL: '/api',
	AUTH_SERVICE: 'https://auth-service-613016217150.australia-southeast1.run.app',
	USER_SERVICE: 'https://user-service-613016217150.australia-southeast1.run.app',
	MISSION_CONTROL_SERVICE: 'https://mission-control-service-613016217150.australia-southeast1.run.app'
};

const test = {
	API_ENDPOINT_URL: '/api',
	AUTH_SERVICE: 'https://auth-service-613016217150.australia-southeast1.run.app',
	USER_SERVICE: 'https://user-service-613016217150.australia-southeast1.run.app',
	MISSION_CONTROL_SERVICE: 'https://mission-control-service-613016217150.australia-southeast1.run.app'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
